<template>
  <v-app id="inspire" class="fill-height">
    <v-main style="overflow: hidden">
      <video id="background-video" autoplay loop muted disablePictureInPicture>
        <source src="../assets/Depositphotos_151324262_1080p.mp4" type="video/mp4" />
      </video>
      <!-- <img id="background-video" src="../assets/Ind.jpg" alt="alt"> -->
      <v-container>
        <v-row align="center" justify="center">
          <v-col class="py-0">
            <div class="form-glass">
              <!-- <v-card-subtitle>
                <img
                  :src="img_azienda"
                  style="
                    max-height: 125px;
                    max-width: 125px;
                    border-radius: 8px;
                    margin-top: 45px;
                    box-shadow:   box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
                    rgba(0, 0, 0, 0.399) 0px 3px 7px -3px;
                  "
                  alt="Quick View"
                />
              </v-card-subtitle> -->
              <span v-if="show_warning && warning_position == 0" :style="'color:' + warning_color"
                class="alert-message">{{ warning_message }}</span>

              <v-card-subtitle style="
                  color: #3f51b5;
                  font-size: 30px;
                  line-height: 1;
                  text-align: center;
                  font-weight: bold;
                  border-radius: 0px 5px 0px 10px;
                  margin-top: 40px;
                  margin-bottom: 40px;
                " class="text">{{ des_titolo_azienda }}</v-card-subtitle>
              <span v-if="show_warning && warning_position == 1" :style="'color:' + warning_color"
                class="alert-message">{{ warning_message }}</span>
              <span v-if="show_error" style="
                  color: rgba(255, 0, 0);
                  font-size: 20px;
                  line-height: 1;
                  text-align: center;
                  font-weight: bold;
                  border-radius: 0px 5px 0px 10px;
                  margin-top: 20px;
                  margin-bottom: 20px;
                  word-wrap: break-word;
                  margin-left: auto;
                  margin-right: auto;
                  width: 25vw;
                  display: block;
                ">{{ error_message }}</span>
              <!-- <v-card-subtitle
                style="
                  font-size: 25px;
                  line-height: 1;
                  text-align: center;
                  border-radius: 0px 5px 0px 10px;
                "
                class="text"
                >{{ testo_azienda }}</v-card-subtitle
              > -->

              <!-- <v-card-subtitle
                style="font-size: 14px; text-align: center"
                >Accedi con le tue credenziali</v-card-subtitle
              > -->
              <v-row align="center" justify="center">
                <v-col>
                  <v-text-field class="input-login-text app-combobox" id="email" color="black" base-color="#3f51b5"
                    readonly @click="clickEmail" style="width: 320px; margin: 0 auto; color: #3f51b5" v-model="email"
                    label="Username" :rules="[rules.required]" v-on:keyup.enter="login()">
                    <template v-slot:prepend-inner>
                      <v-icon color="#3f51b5">mdi-account</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <span v-if="show_warning && warning_position == 2" :style="'color:' + warning_color"
                class="alert-message">{{
                  warning_message }}</span>

              <v-row class="mb-4" align="center" justify="center">
                <v-col>
                  <v-text-field base-color="#3f51b5" class="app-combobox" color="#3f51b5" id="password" label="Password"
                    name="input-10-2" style="margin: 0 auto; max-width: 320px" :rules="[rules.required]"
                    v-model="password" :type="show3 ? 'text' : 'password'" v-on:keyup.enter="login()">
                    <template v-slot:prepend-inner>
                      <v-icon color="#3f51b5">mdi-lock</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-icon @click="show3 = !show3" color="#3f51b5">{{
                        show3 ? "mdi-eye" : "mdi-eye-off"
                      }}</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <span v-if="show_warning && warning_position == 3" :style="'color:' + warning_color"
                class="alert-message">{{
                  warning_message }}</span>

              <v-row align="center" justify="center">
                <v-col>
                  <v-btn elevation="5" :loading="loading3" :disabled="loading3" style="width: 250px" x-large rounded
                    color="indigo" @click="login()"><span style="color: white">Login</span></v-btn>
                </v-col>
              </v-row>

              <span v-if="show_warning && warning_position == 4" :style="'color:' + warning_color"
                class="alert-message">{{
                  warning_message }}</span>

              <v-row>
                <v-col>
                  <v-icon @click="clickQRCode" color="indigo" large>
                    mdi-qrcode-scan
                  </v-icon>
                </v-col>
              </v-row>

              <span v-if="show_warning && warning_position == 5" :style="'color:' + warning_color"
                class="alert-message">{{
                  warning_message }}</span>

              <v-row>
                <v-col>
                  <v-btn style="background-color: white;" class="mb-5" elevation="5" outlined text rounded
                    v-on:click="openDialogRecuperoPassword">
                    <span style="color: #363636">Recupero Password</span>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col>
                  <v-btn style="background-color: white;" class="mb-5" elevation="5" outlined text rounded
                    v-on:click="goToPaginaRecupero">
                    <span style="color: #363636">Cambio Password</span>
                  </v-btn>
                </v-col>
              </v-row>

              <span v-if="show_warning && warning_position == 6" :style="'color:' + warning_color"
                class="alert-message">{{
                  warning_message }}</span>
            </div>
          </v-col>
        </v-row>

        <div style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            color: gray;
            font-size: 12px;
            padding: 2px;
          ">
          v.{{ this.$store.state.versione }}
        </div>
      </v-container>
      <!-- <v-main :style="{ 'background-image': `url(${backgroundUrl})`, 'background-position': 'center' }"> -->

      <v-dialog v-model="dialog_cambia_password" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ titolo_cambio_psw }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field v-if="data_psw == ''" name="passwordOld" label="Password Precedente" id="passwordOld"
                    v-model="passwordOld" :rules="[rules.required]"
                    :append-icon="value_log ? 'visibility' : 'visibility_off'"
                    @click:append="() => (value_log = !value_log)"
                    :type="value_log ? 'password' : 'text'"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field name="password" label="Nuova Password" id="password"
                    :append-icon="value_log ? 'visibility' : 'visibility_off'"
                    @click:append="() => (value_log = !value_log)" :type="value_log ? 'password' : 'text'"
                    v-model="passwordNew" :rules="[rules.required, rules.min, rules.password]"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" name="confirmPassword"
                    label="Conferma Password" id="confirmPassword" :type="showPassword ? 'text' : 'password'"
                    v-model="passwordConfirm" :rules="[comparePasswords, rules.required]"
                    @click:append="showPassword = !showPassword"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog_cambia_password = false">Chiudi</v-btn>
            <v-btn color="blue darken-1" text @click="salvaNuovaPassword">Salva</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_recupero_password" persistent width="30vw">
        <v-card>
          <v-toolbar dense color="indigo" dark align="center">
            <v-toolbar-title>Recupero Password</v-toolbar-title>
            <v-spacer />
            <v-btn small light @click="recuperoPassword">
              <v-icon color="success">mdi-check</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn small light @click="dialog_recupero_password = false">
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="background-color: white">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field name="emailRecupero" label="Email" id="emailRecupero" type="email"
                    v-model="emailRecupero" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Utente" v-model="utenteRecupero" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog del lettore QR code -->
      <v-dialog v-model="qr_reader_visible" width="75%" persistent>
        <v-toolbar dense style="
            background-color: rgba(255, 255, 255, 0.13);
            backdrop-filter: blur(8px);
            color: white;
            box-shadow: 0 0 40px rgba(8, 7, 16, 0.6);
          ">
          <v-toolbar-title>QR CODE Login </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="handleCloseQRDialog" color="error">
            mdi-close
          </v-icon>
        </v-toolbar>
        <qrcode-stream :camera="camera" @decode="handleOnDecode"></qrcode-stream>
      </v-dialog>
    </v-main>

    <v-dialog v-model="dialog" width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ titolo_modal }}</span>
        </v-card-title>
        <v-card-text>{{ testo_modal }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="rifiutoDialog()">Rifiuto</v-btn>
          <v-btn color="green darken-1" text @click="accettoDialog()">Accetto</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog class="ma-0 pa-0" v-model="allegatiVisible" width="90vw" persistent>
      <v-card class="ma-0 pa-0" height="calc(100vh - 100px)" style="overflow: hidden">
        <div style="position: relative; height: 100%">
          <WindowFrame class="ma-0 pa-0" referrerpolicy="origin" @click_chiudi="closeAllegati" :component="'allegati'"
            ref="windowframe_allegati" :input_args="inputArgs" :key="keyAllegati" />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog class="ma-0 pa-0" v-model="dialogContatti" width="90vw" persistent>
      <v-card class="ma-0 pa-0" height="calc(100vh - 100px)" style="overflow: hidden">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Contatti</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small @click="logout">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <div style="position: relative; height: 100%">
          <ContattiAllegati class="ma-0 pa-0" :id_anagrafica="id_anagrafica" @openAllegati="openAllegati" />
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar :color="colore_snackbar" v-model="snackbar">
      {{ this.messaggio_errore }}
      <v-btn color="white" text @click="snackbar = false">Chiudi</v-btn>
    </v-snackbar>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-app>
</template>

<script>
import backgroundUrl from "../assets/logo.png";
//import axios from "axios";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import ContattiAllegati from "@/components/TOOLS/ContattiAllegati.vue";
import config from "../../public/config";
import { firebase } from "../plugins/firebase";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  components: {
    WindowFrame,
    SnackbarQV,
    ContattiAllegati,
  },
  data() {
    return {
      dialogContatti: false,
      inputArgs: {
        cod_riferimento: "anagrafica_contatti",
        id_riferimento: -1,
        pk_riferimento: "id_anagrafica_contatti",
      },
      id_anagrafica: -1,
      allegatiVisible: false,
      keyAllegati: true,
      warning_position: 0,
      warning_color: "rgb(255, 127, 0)",
      show_warning: false,
      warning_message: "",
      error_message: "",
      show_error: false,
      utenteRecupero: "",
      backgroundUrl,
      config: config,
      snackbar: false,
      value: String,
      value_rip: String,
      value_log: String,
      loading3: false,
      show3: false,
      img_azienda: "../assets/logo2.png",
      email: "",
      messaggio_errore: "Email o Password errati!",
      password: "",
      ripeti_password_reg: "",
      password_red: "",
      n_tessera_reg: "",
      email_reg: "",
      titolo_azienda: "",
      nome_reg: "",
      cognome_reg: "",
      data_psw: "",
      titolo_cambio_psw: "Cambio Password Obbligatorio",
      dialog_cambia_password: false,
      idUtentePasswordNew: -1,
      passwordNew: "",
      passwordConfirm: "",
      passwordOld: "",
      showPassword: false,
      colore_snackbar: "error",
      dialog: false,
      tokenJwt: "",
      testo_modal: "",
      arrayAvvisi: [],
      testo_azienda: "",
      check_privacy: 0,
      check_termini: 0,
      check_avvisi: 0,
      des_titolo_azienda: "Benvenuto in QuickView",
      tipo: "",
      titolo: "",
      testo: "",
      titolo_modal: "",
      avvisoAttuale: 0,
      dialog_recupero_password: false,
      emailRecupero: "",
      rules: {
        required: (value) => !!value || "Campo obbligatorio",
        min: (v) => v.length >= 8 || "Min 8 caratteri",
        password: (value) => {
          const pattern =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
          return (
            pattern.test(value) ||
            "Min. 8 caratteri con almeno una lettera maiuscola, un numero, e un carattere speciale."
          );
        },
      },
      camera: "off",
      qr_reader_visible: false,
    };
  },
  name: "Login",
  props: {
    source: String,
  },
  watch: {
    email: {
      immediate: true,
      handler() {
        let temp = document.getElementById("password");
        if (temp != null) {
          temp.removeAttribute("readOnly");
        }
      },
    },
  },
  computed: {
    comparePasswords() {
      return this.passwordNew === this.passwordConfirm
        ? true
        : "La password non coincide";
    },
  },
  mounted() {
    // Mi preparo a intercettare un login andato male.
    if (document.getElementById("inspire")) {
      document
        .getElementById("inspire")
        .addEventListener("not_allowed", this.printNotAllowed);
      document
        .getElementById("inspire")
        .addEventListener("error_api", this.printErrorApi);
    }

    var name_azienda = window.location.href
      .replace("https://", "")
      .replace("http://", "");
    var sup = name_azienda.split(".");
    if (sup[0].startsWith("localhost")) {
      sup[0] = "test";
    }
    localStorage.setItem("url", name_azienda);
    this.getInfoAzienda(sup[0]);

    var url = window.location.href.split("?");
    if (url.length > 1) {
      this.data_psw = url[1].replace("k=", "");
      this.dialog_cambia_password = true;
      this.titolo_cambio_psw = "Reimposta la tua password";
    } else {
      this.titolo_cambio_psw = "Cambio Password Obbligatorio";
    }
  },
  methods: {
    goToPaginaRecupero(){
      this.$router.push("/recupero/1");
    },
    openAllegati(arg) {
      this.inputArgs.id_riferimento = arg.id_anagrafica_contatti;
      this.keyAllegati = !this.keyAllegati;
      this.allegatiVisible = true;
    },
    closeAllegati() {
      if (this.dialogContatti) {
        this.allegatiVisible = false;
      } else {
        this.logout();
      }
    },
    async getInfoAzienda(azienda) {
      var request = {
        controller: "Token",
        method: "POST",
        richiesta: {
          action: "getinfoazienda",
          nome_azienda: azienda,
        },
      };
      const res = await this.$store.dispatch("api", request);
      // Se la risposta è ok, prendo i dati
      if (res.data.response !== false) {
        /* Per prima cosa controllo che il FE sia aggiornato.
         * Se la data_versione è false vuol dire che nel BE
         * c'è qualcosa di strano e non registro questa data.
         * Se la data è valida non lo è, ricarico e rifaccio. */
        if (
          typeof res.data.result.avvisi_login != "undefined" &&
          res.data.result.avvisi_login != null
        ) {
          this.warning_position = Math.floor(Math.random() * 7);
          this.warning_color =
            "rgb(" +
            Math.floor(Math.random() * 256) +
            "," +
            Math.floor(Math.random() * 256) +
            "," +
            Math.floor(Math.random() * 256) +
            ")";
          this.show_warning = true;

          if (res.data.result.avvisi_login[0]) {
            this.warning_message = res.data.result.avvisi_login[0].testo;
          }
        }
        if (
          res.data.result.info_azienda &&
          res.data.result.info_azienda[0] &&
          res.data.result.info_azienda[0].data_versione
        ) {
          if (
            localStorage.data_versione !==
            res.data.result.info_azienda[0].data_versione
          ) {
            localStorage.setItem(
              "data_versione",
              res.data.result.info_azienda[0].data_versione
            );
            window.location.reload(true);
            return;
          }
        }

        if (
          res.data.result.info_azienda[0].img_azienda != null &&
          res.data.result.info_azienda[0].img_azienda != ""
        )
          this.img_azienda = res.data.result.info_azienda[0].img_azienda;
        localStorage.setItem("img_azienda", this.img_azienda);
        if (
          res.data.result.info_azienda[0].ragione_sociale != null &&
          res.data.result.info_azienda[0].ragione_sociale != ""
        ) {
          this.titolo_azienda = res.data.result.info_azienda[0].ragione_sociale;
          localStorage.setItem("titolo_azienda", this.titolo_azienda);
        }
        if (
          res.data.result.info_azienda[0].testo_azienda != null &&
          res.data.result.info_azienda[0].testo_azienda != ""
        ) {
          this.testo_azienda = res.data.result.info_azienda[0].testo_azienda;
          localStorage.setItem(
            "testo_azienda",
            res.data.result.info_azienda[0].testo_azienda
          );
        }
        if (
          res.data.result.info_azienda[0].titolo != null &&
          res.data.result.info_azienda[0].titolo != ""
        ) {
          this.des_titolo_azienda = res.data.result.info_azienda[0].titolo;
          localStorage.setItem(
            "des_titolo_azienda",
            res.data.result.info_azienda[0].titolo
          );
        }
        if (
          res.data.result.info_azienda[0].prefisso_utente != null &&
          res.data.result.info_azienda[0].prefisso_utente != ""
        ) {
          this.$store.state.prefisso_utente =
            res.data.result.info_azienda[0].prefisso_utente;
          // localStorage.setItem(
          //   "prefisso_utente",
          //   res.data.result.info_azienda[0].prefisso_utente
          // );
        }
      }
    },
    accettoDialog() {
      // const config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      // var finale = {
      //   action: "setcheckutente",
      //   id: localStorage.id,
      //   dbname: "medical",
      //   tipo: this.arrayAvvisi[this.avvisoAttuale].tipo,
      //   token: this.tokenJwt,
      // };

      var request = {
        controller: "Token",
        method: "PUT",
        richiesta: {
          action: "setcheckutente",
          id: localStorage.id,
          dbname: "medical",
          tipo: this.arrayAvvisi[this.avvisoAttuale].tipo,
          token: this.tokenJwt,
        },
      };
      this.$store.dispatch("api", request).then((response) => {
        this.azienda = response.data[0];
      });

      if (this.avvisoAttuale === this.arrayAvvisi.length - 1) {
        localStorage.setItem("user_token", this.tokenJwt);
        this.$router.replace("home/");
      } else {
        this.avvisoAttuale++;
        this.titolo_modal = this.arrayAvvisi[this.avvisoAttuale].titolo;
        this.testo_modal = this.arrayAvvisi[this.avvisoAttuale].testo;
        this.dialog = true;
      }
    },
    clickEmail() {
      document.getElementById("email").removeAttribute("readOnly");
    },
    rifiutoDialog() {
      this.avvisoAttuale = 0;
      this.dialog = false;
      this.$logout();
      this.loading3 = false;
    },
    openDialogNuovaPassword: function () {
      this.passwordOld = "";
      this.passwordNew = "";
      this.passwordConfirm = "";
      this.idUtentePasswordNew = -1;
      this.loading3 = false;
      this.dialog_cambia_password = true;
    },
    salvaNuovaPassword: function () {
      this.idUtentePasswordNew = localStorage.id;

      // const config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      //var finale;
      if (this.data_psw != "" && this.data_psw != null) {
        if (
          this.idUtentePasswordNew == -1 ||
          this.passwordNew == "" ||
          this.passwordConfirm == "" ||
          this.passwordNew != this.passwordConfirm
        ) {
          this.colore_snackbar = "error";
          this.messaggio_errore =
            "Errore: Compilare correttamente tutti i campi";
          this.snackbar = true;
          return;
        }
        // finale = {
        //   action: "setrecuperopsw",
        //   dbname: "medical",
        //   password: this.passwordNew,
        //   data: this.data_psw,
        // };
        // var data = JSON.stringify(finale);

        var request = {
          controller: "Token",
          method: "POST",
          richiesta: {
            action: "setrecuperopsw",
            dbname: "medical",
            password: this.passwordNew,
            data: this.data_psw,
          },
        };
        this.$store.dispatch("api", request).then(() => {
          this.passwordOld = "";
          this.passwordNew = "";
          this.passwordConfirm = "";
          this.idUtentePasswordNew = -1;
          this.dialog_cambia_password = false;
          this.colore_snackbar = "success";
          this.messaggio_errore = "Password Modificata";
          this.snackbar = true;
          this.password = "";
          this.loading3 = false;
          this.$logout();
        });
      } else {
        if (
          this.idUtentePasswordNew == -1 ||
          this.passwordNew == "" ||
          this.passwordOld == "" ||
          this.passwordConfirm == "" ||
          this.passwordNew != this.passwordConfirm
        ) {
          this.colore_snackbar = "error";
          this.messaggio_errore =
            "Errore: Compilare correttamente tutti i campi";
          this.snackbar = true;
          return;
        }
        // finale = {
        //   action: "putcambio",
        //   id_utente: this.idUtentePasswordNew,
        //   dbname: "medical",
        //   old: this.passwordOld,
        //   new: this.passwordNew,
        //   token: this.tokenJwt,
        // };
        // data = JSON.stringify(finale);
        request = {
          controller: "Token",
          method: "PUT",
          richiesta: {
            action: "putcambio",
            id_utente: this.idUtentePasswordNew,
            dbname: "medical",
            old: this.passwordOld,
            new: this.passwordNew,
            token: this.tokenJwt,
          },
        };
        this.$store.dispatch("api", request).then((response) => {
          if (response.status == 200) {
            if (response.data.attivo == 0) {
              this.loading3 = false;
              this.colore_snackbar = "error";
              this.messaggio_errore =
                "Errore:  L'utente non è attivo, contattare un responsabile";
              this.snackbar = true;
              return;
            }
            this.passwordOld = "";
            this.passwordNew = "";
            this.passwordConfirm = "";
            this.idUtentePasswordNew = -1;
            this.dialog_cambia_password = false;
            this.colore_snackbar = "success";
            this.messaggio_errore = "Password Modificata";
            this.snackbar = true;
            this.password = "";
            this.loading3 = false;
            localStorage.clear();
          } else {
            this.colore_snackbar = "orange";
            this.messaggio_errore = "Errore di modifica password";
            this.snackbar = true;
          }
        });
      }
    },

    openDialogRecuperoPassword: function () {
      this.emailRecupero = "";
      this.dialog_recupero_password = true;
    },

    recuperoPassword: function () {
      if (this.emailRecupero == "") {
        //compilare tutto
        this.colore_snackbar = "error";
        this.messaggio_errore = "Errore: Compilare correttamente tutti i campi";
        this.snackbar = true;
        return;
      }

      // const config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      // var finale = {
      //   action: "getrecuperopsw",
      //   db_name: "medical",
      //   email: this.emailRecupero,
      // };
      // var data = JSON.stringify(finale);

      var request = {
        controller: "Token",
        method: "POST",
        richiesta: {
          action: "recuperopswnew",
          username: this.utenteRecupero,
          email: this.emailRecupero,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((response) => {
          this.emailRecupero = "";
          this.dialog_recupero_password = false;

          if (response.status == "200") {
            this.colore_snackbar = "success";
            this.messaggio_errore = "Email Inviata.\nControlla la tua email";
          } else {
            this.colore_snackbar = "error";
            this.messaggio_errore = "Impossibile resettare password";
          }

          this.snackbar = true;
        })
        .catch(() => {
          this.colore_snackbar = "error";
          this.messaggio_errore = "Impossibile resettare password";
          this.snackbar = true;
        });
    },

    invioLogin: function (e) {
      if (e.keyCode === 13) {
        this.login();
      }
    },

    login() {
      this.loading3 = true;
      if (this.email == "" || this.password == "") {
        //compilare tutto
        this.colore_snackbar = "error";
        this.messaggio_errore = "Compilare correttamente username e password";
        this.snackbar = true;
        this.loading3 = false;
        return;
      }

      // const config = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      var request = {
        controller: "Token",
        method: "POST",
        richiesta: {},
      };

      /*if (
        localStorage.prefisso_utente != null &&
        localStorage.prefisso_utente != undefined &&
        localStorage.prefisso_utente != "" &&
        !this.email.includes("/")
      ) {
        request.richiesta = {
          username: this.email,
          password: this.password,
          prefisso_utente: localStorage.prefisso_utente,
        };
      } else */

      var prefisso = "";

      // if (localStorage.url) {
      //   prefisso = localStorage.url.split(".")[0];
      // }

      prefisso = window.location.href.split("//")[1].split(".")[0];

      if (
        prefisso == "www" ||
        prefisso == "quickview" ||
        prefisso.startsWith("localhost") ||
        prefisso.startsWith("wwwtest") ||
        prefisso.startsWith("test") ||
        prefisso.startsWith("qtestv3") ||
        prefisso.startsWith("archive")
      ) {
        if (this.email.includes("/")) {
          prefisso = this.email.split("/")[0];
        } else {
          this.colore_snackbar = "error";
          this.messaggio_errore = "È necessario includere il prefisso utente";
          this.snackbar = true;
          this.loading3 = false;
          return;
        }
      } else {
        if (this.email.includes("/")) {
          if (this.email.split("/")[0] != prefisso) {
            this.colore_snackbar = "error";
            this.messaggio_errore = "Prefisso utente non valido.";
            this.snackbar = true;
            this.loading3 = false;

            console.error(
              "Errore di autenticazione per email e prefisso: " +
              this.email.split("/")[0] +
              " e " +
              prefisso
            );
            return;
          }
        }
      }

      if (this.email.includes("/")) {
        var username = this.email.split("/");
        request.richiesta = {
          username: username[1],
          password: this.password,
          prefisso_utente: prefisso,
          url: localStorage.url,
        };
      } else {
        request.richiesta = {
          username: this.email,
          password: this.password,
          prefisso_utente: prefisso,
          url: localStorage.url,
        };
      }

      this.$store
        .dispatch("api", request)
        .then((response) => {
          // Interrompo l'overlay di caricamento.
          this.loading3 = false;

          if (response.data.jwt != null && response.data.jwt != "") {
            let data_versione = localStorage.data_versione;
            localStorage.clear();
            localStorage.data_versione = data_versione;
            localStorage.setItem("is_contatto", "0");
            if (response.data.attivo == 0) {
              this.loading3 = false;
              //controllare password ed utente

              this.colore_snackbar = "error";
              this.messaggio_errore =
                "L'utente non è attivo, contattare il personale!";
              this.snackbar = true;
              return;
            }

            if (
              response.data.dns != null &&
              response.data.dns != "" &&
              !window.location.href.includes("localhost") &&
              !window.location.href.startsWith(response.data.dns)
            ) {
              window.location.href = response.data.dns;
              return;
            }

            if (
              response.data.quickconnext_backend != null &&
              response.data.quickconnext_backend != ""
            ) {
              localStorage.setItem(
                "quickconnext_backend",
                response.data.quickconnext_backend
              );
            }

            localStorage.setItem("user_token", response.data.jwt);
            //this.$SSEController.connect(response.data.jwt);

            localStorage.setItem(
              "moduli_dx",
              JSON.stringify(response.data.moduloDx)
            );
            localStorage.setItem(
              "moduli_sx",
              JSON.stringify(response.data.moduloSx)
            );
            localStorage.setItem("id", response.data.id);
            localStorage.setItem("nominativo", response.data.nominativo);
            localStorage.setItem("des_profilo", response.data.des_profilo);
            localStorage.setItem("id_profilo", response.data.id_profilo);
            localStorage.setItem("username", request.richiesta.username);
            localStorage.setItem("des_azienda", response.data.des_azienda);
            localStorage.setItem("cod_azienda", response.data.cod_azienda);
            localStorage.setItem("id_azienda", response.data.id_azienda);
            localStorage.setItem("cod_profilo", response.data.cod_profilo);
            localStorage.setItem("chat", response.data.firebase_ok);
            localStorage.setItem("dbname", response.data.dbname);
            localStorage.setItem("email", response.data.email);
            localStorage.setItem("orari_attivi", response.data.orari_attivi);
            localStorage.setItem(
              "prefisso_user",
              response.data.prefisso_utente
            );
            /* Il prefisso utente serve per il WindowFrame e in particolare
             * per Contabilità e il cliente Fiorenzo, eventalmente fare riferimento
             * a Patrizio. */
            localStorage.setItem(
              "prefisso_utente",
              response.data.prefisso_utente
            );
            localStorage.setItem("task_validi", response.data.task_validi);
            localStorage.setItem("task_scaduti", response.data.task_scaduti);

            //  Info accesso ai moduli amministrativi
            let auth_level = Number(response.data.auth_level);
            if (auth_level >= 0) {
              auth_level = new Uint32Array([auth_level])[0];
            }
            localStorage.auth_level = auth_level;
            // this.$store.state.auth_level = auth_level;
            // this.$store.state.show_admin_tools =
            localStorage.show_admin_tools = auth_level == -1 || auth_level > 0;

            if (response.data.check_privacy === "1") {
              this.check_privacy = 1;
            }
            if (response.data.check_termini === "1") {
              this.check_termini = 1;
            }
            if (response.data.check_avvisi === "1") {
              this.check_avvisi = 1;
            }

            if (response.data.check_privacy === "1") {
              this.check_privacy = 1;
            }
            if (response.data.check_termini === "1") {
              this.check_termini = 1;
            }
            if (response.data.check_avvisi === "1") {
              this.check_avvisi = 1;
            }

            if (response.data.cambio_obbligatorio == "True") {
              this.$router.replace("recupero/1");
              return;
            }

            this.arrayAvvisi = [];
            if (response.data.cambio_password == 1) {
              this.tokenJwt = response.data.jwt;
              localStorage.removeItem("user_token");
              this.loading3 = false;
              this.dialog_cambia_password = true;
            } else {
              if (
                this.check_privacy != 1 &&
                response.data.privacy != null &&
                response.data.privacy != "" &&
                response.data.privacy != undefined
              ) {
                this.tokenJwt = response.data.jwt;
                localStorage.removeItem("user_token");
                this.titolo_modal = "PRIVACY";
                this.testo_modal = response.data.privacy;
                var obj = {
                  testo: response.data.privacy,
                  titolo: "PRIVACY",
                  tipo: "privacy",
                };
                this.arrayAvvisi.push(obj);
              }
              if (
                this.check_termini != 1 &&
                response.data.termini_uso != null &&
                response.data.termini_uso != "" &&
                response.data.termini_uso != undefined
              ) {
                this.tokenJwt = response.data.jwt;
                localStorage.removeItem("user_token");
                this.titolo_modal = "TERMINI D' USO";
                this.testo_modal = response.data.termini_uso;
                var objx = {
                  testo: response.data.termini_uso,
                  titolo: "TERMINI D' USO",
                  tipo: "termini_uso",
                };
                this.arrayAvvisi.push(objx);
              }
              if (this.arrayAvvisi.length > 0) {
                this.titolo_modal = this.arrayAvvisi[this.avvisoAttuale].titolo;
                this.testo_modal = this.arrayAvvisi[this.avvisoAttuale].testo;
                this.dialog = true;
                return;
              }
              //CONTROLLO SE HA LOGINCON FIREBASE PRIMA
              try {
                if (
                  response.data.email != "" &&
                  response.data.firebase_ok == "1"
                ) {
                  firebase
                    .auth()
                    //.signInWithEmailAndPassword("l.squillaci@getsoft.it", "123456")
                    .signInWithEmailAndPassword(response.data.email, "123456")
                    .then(
                      () => {
                        this.$router.replace("home/");
                        this.loading3 = false;
                      },
                      (err) => {
                        this.loading3 = false;
                        console.error("err firebase", err);
                      }
                    );
                } else if (
                  localStorage.cod_azienda === "EM" &&
                  localStorage.cod_profilo === "addetto_produzione"
                ) {
                  this.$router.replace("home/electrical/EMProduzione");
                } else {
                  this.$router.replace("home/");
                }
              } catch (error) {
                console.error(error);
                this.$router.replace("home/");
              }
            }
          } else if (
            response.data.contatto_token != null &&
            response.data.contatto_token != ""
          ) {
            localStorage.setItem("is_contatto", "1");
            localStorage.setItem("user_token", response.data.contatto_token);

            localStorage.setItem("id", response.data.id);
            this.inputArgs.id_riferimento = response.data.id;
            localStorage.setItem("nominativo", response.data.nominativo);
            localStorage.setItem("des_profilo", response.data.des_profilo);
            localStorage.setItem("id_profilo", response.data.id_profilo);
            localStorage.setItem("des_azienda", response.data.des_azienda);
            localStorage.setItem("cod_azienda", response.data.cod_azienda);
            localStorage.setItem("id_azienda", response.data.id_azienda);
            localStorage.setItem("cod_profilo", response.data.cod_profilo);
            localStorage.setItem("dbname", response.data.dbname);
            localStorage.setItem(
              "prefisso_user",
              response.data.prefisso_utente
            );

            localStorage.setItem(
              "prefisso_utente",
              response.data.prefisso_utente
            );
            this.id_anagrafica = parseInt(response.data.id_anagrafica);
            if (localStorage.id_profilo == "1") {
              this.dialogContatti = true;
            } else {
              this.allegatiVisible = true;
            }
          } else {
            //controllare password ed utente
            this.showError(response.data.result);
          }
        })
        .catch((e) => {
          // Interrompo l'overlay di caricamento.
          this.loading3 = false;
          this.showError(e.response.data.result);

          const name_azienda = window.location.href
            .replace("https://", "")
            .replace("http://", "");
          localStorage.setItem("url", name_azienda);
        });
    },
    logout() {
      this.email = "";
      this.password = "";
      this.$logout();
      this.allegatiVisible = false;
      this.dialogContatti = false;
    },
    showError(arg) {
      this.show_error = true;
      this.error_message = arg;
    },
    handleOnDecode(arg) {
      this.email = arg.split("(Q)")[1].split(";")[0];
      this.password = arg.split("(H)")[1].split(";")[0];
      this.camera = "off";
      this.qr_reader_visible = false;

      this.login();
    },
    clickQRCode() {
      this.qr_reader_visible = true;
      this.camera = "auto";
    },
    handleCloseQRDialog() {
      this.qr_reader_visible = false;
      this.camera = "off";
    },
    noop() {
      // do nothing ?
    },
  },
  beforeDestroy() {
    if (document.getElementById("inspire")) {
      document
        .getElementById("inspire")
        .removeEventListener("not_allowed", this.printNotAllowed);
      document
        .getElementById("inspire")
        .removeEventListener("error_api", this.printErrorApi);
    }
  },
};
</script>

<style lang="scss">
.alert-message {
  font-size: 20px;
  line-height: 1;
  text-align: center;
  font-weight: bold;
  border-radius: 0px 5px 0px 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  word-wrap: break-word;
  margin-left: auto;
  margin-right: auto;
  width: 25vw;
  display: block;
  -webkit-text-stroke: 1px black;
}

#background-video {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.9;
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition: background-color 0s 600000s, color 0s 600000s !important;
}

.form-glass {
 // border: 2px solid rgba(44, 44, 44, 0.658);
  background: #ffffff;
  background: linear-gradient(0deg, rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0.804) 50%, rgba(255, 255, 255, 0.468) 100%);
  box-shadow: 3px 3px 50px 3px rgba(30, 30, 30, 0.847);
  border-radius: 12px;
  filter: brightness(1);
  position: absolute;
  bottom: 15%;
  left: 5%;
  width: 380px;
  margin-left: 0px;
  backdrop-filter: blur(90px);
  -webkit-backdrop-filter: blur(90px);
}

.input-login-text input {
  color: black !important;
}

@media screen and (max-width: 920px) {
  .form-glass {
    background: linear-gradient(0deg,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0.3) 100%);
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    border-radius: 0px;
    backdrop-filter: blur(22px);
    -webkit-backdrop-filter: blur(22px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    min-width: 100%;
    height: 100vh;
    margin: 0px;
    padding: 20px;
  }

  #background-video {
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0.95;
  }
}

.dialog-glass {
  background-color: rgba(255, 255, 255, 0.741);
  border-radius: 10px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 40px rgba(8, 7, 16, 0.6);
}

.centered-container {
  display: flex;
  position: relative;
  height: 100vh;

  .title {
    text-align: center;
    margin-bottom: 30px;

    img {
      margin-bottom: 16px;
      max-width: 80px;
    }
  }

  .actions {
    .md-button {
      margin: 0;
    }
  }

  .form {
    margin-bottom: 60px;
  }

  .md-content {
    z-index: 1;
    padding: 40px;
    width: 100%;
    max-width: 400px;
    position: relative;
  }

  .loading-overlay {
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
